/* CAMBIOS DE VARIANTES */
// collection variant change -- steven
$(document).on("click", "product-item.product-item .product-item__general-product .variants-metafiels button.label-variant", function () {
  let item = $(this).parents('.product-item__general-product');
  let templates = item.next('.templates-collection');
  let templateId = $(this).data('id');
  let templateElement = templates.find(`template#${templateId}`);
  if (templateElement.length) {
    let content = $(templateElement[0].content).find('.product-item__general-product');
    let templateContent = content.html();
    item.html(templateContent);
    item.find('.number-input').each(function () {
      updateButtons($(this));
    });
  } else {
    console.error(`No se encontró el template con el ID: ${templateId}`);
  }
});




/* CAMBIOS DE CANTIDAD */

$(document).on("click", "product-item.product-item .number-input button.increase", function() {
  const $container = $(this).closest('.number-input');
  const $input = $container.find('.number-input-field');
  const maxValue = parseInt($input.attr('max'));
  let currentValue = parseInt($input.val());

  if (currentValue < maxValue) {
    $input.val(currentValue + 1);
  }
  updateButtons($container);
});

$(document).on("click", "product-item.product-item .number-input button.decrease", function() {
  const $container = $(this).closest('.number-input');
  const $input = $container.find('.number-input-field');
  const minValue = parseInt($input.attr('min'));
  let currentValue = parseInt($input.val());

  if (currentValue > minValue) {
    $input.val(currentValue - 1);
  }
  updateButtons($container);
});




$(document).on("input", ".number-input-field", function () {
  const $input = $(this);
  const $container = $input.closest('.number-input');
  const $increaseButton = $container.find('.increase');
  const $decreaseButton = $container.find('.decrease');

  const maxValue = parseInt($input.attr('max'));
  let currentValue = parseInt($input.val());

  if (isNaN(currentValue) || $input.val() === "") {
    currentValue = 1;
    $input.val(currentValue);
  }

  if (currentValue > maxValue) {
    $input.val(maxValue);
  } else if (currentValue < 1) {
    $input.val(1);
  }

  const updatedValue = parseInt($input.val());

  $decreaseButton.prop('disabled', updatedValue <= 1);
  $increaseButton.prop('disabled', updatedValue >= maxValue);
});






function updateButtons($container) {
  const $input = $container.find('.number-input-field');
  const $increaseButton = $container.find('.increase');
  const $decreaseButton = $container.find('.decrease');

  const currentValue = parseInt($input.val());
  const minValue = parseInt($input.attr('min'));
  const maxValue = parseInt($input.attr('max'));

  $decreaseButton.prop('disabled', currentValue <= minValue);
  $increaseButton.prop('disabled', currentValue >= maxValue);
}

$('product-item.product-item .number-input').each(function() {
  updateButtons($(this));
});






/* AGREGAR AL CARRITO */

function addToCartCollection(id) {
  
  const $button = $(event.target);
  const $container = $button.closest('.cta-buttons-eject');
  const $input = $container.find('.number-input-field');
  const quantity = parseInt($input.val());

  if (!quantity || quantity < 1) {
    console.error('Cantidad no válida');
    return;
  }

  $button.text('ADDING...');
  $button.prop('disabled', true);

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      id: id,
      quantity: quantity
    },
    dataType: 'json',
    success: function() {
      $button.text('ADDED!');
      
      setTimeout(() => {
        $button.text('ADD TO CART');
        $button.prop('disabled', false);
      }, 1000);

      console.log('Productos agregados al carrito con éxito');
    },
    error: function(XMLHttpRequest, textStatus, errorThrown) {
      $button.text('ERROR');
      setTimeout(() => {
        $button.text('ADD TO CART');
        $button.prop('disabled', false);
      }, 1000);

      console.log('Error al agregar los productos al carrito');
    }
  });
}
